var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66748 10L13.3341 10M13.3341 10L10.4175 7.5M13.3341 10L10.4175 12.5",
    stroke: "#A020FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50159 5.83268C7.51168 4.02016 7.59205 3.03857 8.23237 2.39825C8.9646 1.66602 10.1431 1.66602 12.5001 1.66602L13.3335 1.66602C15.6905 1.66602 16.869 1.66602 17.6012 2.39825C18.3335 3.13048 18.3335 4.30899 18.3335 6.66602L18.3335 13.3327C18.3335 15.6897 18.3335 16.8682 17.6012 17.6004C16.869 18.3327 15.6905 18.3327 13.3335 18.3327L12.5001 18.3327C10.1431 18.3327 8.9646 18.3327 8.23237 17.6004C7.59205 16.9601 7.51168 15.9785 7.50159 14.166",
    stroke: "#A020FF",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/Disconnect.cc2f7cbb6df5177cd7f313a3a13a56ef.svg";
export { ForwardRef as ReactComponent };